document.addEventListener('DOMContentLoaded', () => {
  const goPrev = (component) => {
    const loop = component.querySelector('.js-loop-fade');
    const childVisibleClass = loop.dataset.childVisibleClass;
    const active = loop.querySelector(`.${childVisibleClass}`);
    const prev = active.previousElementSibling || active.parentElement.lastElementChild;

    active.classList.remove(childVisibleClass);
    prev.classList.add(childVisibleClass);

    component.querySelector('.c-bannerhome__legend').textContent = prev.dataset.legend;
  };

  const goNext = (component) => {
    const loop = component.querySelector('.js-loop-fade');
    const childVisibleClass = loop.dataset.childVisibleClass;
    const active = loop.querySelector(`.${childVisibleClass}`);
    const next = active.nextElementSibling || active.parentElement.firstElementChild;

    active.classList.remove(childVisibleClass);
    next.classList.add(childVisibleClass);

    component.querySelector('.c-bannerhome__legend').textContent = next.dataset.legend;
  };

  document.querySelectorAll('.js-loop-fade').forEach((loop) => {
    const component = loop.closest('.c-bannerhome');
    const progressBar = component.querySelector('.c-bannerhome__progress-bar');
    progressBar.addEventListener('animationiteration', () => {
      goNext(component);
    });
  });

  document.querySelectorAll('.js-playpause').forEach((playpause) => {
    playpause.addEventListener('click', () => {
      const loop = playpause.closest('.c-bannerhome');
      loop.classList.toggle('c-bannerhome--paused');
    });
  });

  document.querySelectorAll('.js-prev').forEach((prev) => {
    prev.addEventListener('click', () => {
      const component = prev.closest('.c-bannerhome');
      const progressBar = component.querySelector('.c-bannerhome__progress-bar');
      progressBar.getAnimations().forEach((animation) => {
        animation.currentTime = 0;
      });
      goPrev(component);
    });
  });

  document.querySelectorAll('.js-next').forEach((next) => {
    next.addEventListener('click', () => {
      const component = next.closest('.c-bannerhome');
      const progressBar = component.querySelector('.c-bannerhome__progress-bar');
      progressBar.getAnimations().forEach((animation) => {
        animation.currentTime = 0;
      });
      goNext(component);
    });
  });
});
